export const getUrl = (which) =>
  `${process.env.REACT_APP_BASE_URL}/${process.env[which]}`;

export const getStripeUrl = (which) =>
  `${process.env.REACT_APP_BILLING_BASE_URL}/${process.env[which]}`;

export const getCmsUrl = (which) =>
  `${process.env.REACT_APP_CMS_BASE_URL}/${process.env[which]}`;
